import { graphql, HttpResponse } from 'msw'
import {
  InvestmentAmountType,
  InvestmentTradeStatus,
  type InvestmentTransferActivityDetailV2,
  InvestmentTransferStatus,
  InvestmentTransferType,
  type InvestmentAccountActivity,
  type InvestmentDividendActivityDetailV2,
  type InvestmentFeeActivityDetail,
  type InvestmentInterestActivityDetail,
  type InvestmentAcatGroupActivityDetailV2,
  type InvestmentActivityAcatStock,
  AcatDirection,
  type InvestmentActivityAcatCash,
} from '../../../models'

export const investmentAccountActivityMock: InvestmentAccountActivity = {
  activity: [
    {
      __typename: 'InvestmentTransferActivityDetailV2',
      activityId: 10,
      displayName: 'Deposit from High Yield Checking',
      date: new Date().toISOString(),
      amount: {
        amount: 1000,
        currencyCode: 'USD',
      },
      initiatedAmount: {
        amount: 1000,
        currencyCode: 'USD',
      },
      transferType: InvestmentTransferType.DEPOSIT,
      transferStatus: InvestmentTransferStatus.PROCESSING_FUNDS,
      counterparty: 'High Yield Checking',
      initiatedDate: new Date().toISOString(),
      completedDate: undefined, // nullable my be in flux
      trades: [
        {
          tradeId: 101,
          displayName: 'Apple',
          symbol: 'AAPL',
          amount: 0.00313438,
          amountType: InvestmentAmountType.NOMINAL,
          status: InvestmentTradeStatus.PENDING,
        },
        {
          tradeId: 102,
          displayName: 'Amazon',
          symbol: 'AMZN',
          amount: 0.004567789,
          amountType: InvestmentAmountType.NOMINAL,
          status: InvestmentTradeStatus.PENDING,
        },
        {
          tradeId: 103,
          displayName: 'Netflix',
          symbol: 'NFLX',
          status: InvestmentTradeStatus.PENDING,
        },
      ],
    } as InvestmentTransferActivityDetailV2,
    {
      __typename: 'InvestmentTransferActivityDetailV2',
      activityId: 12,
      displayName: 'Withdrawal from High Yield Checking',
      date: new Date().toISOString(),
      initiatedAmount: {
        amount: 1001,
        currencyCode: 'USD',
      },
      amount: {
        amount: 999.02,
        currencyCode: 'USD',
      },
      settledAmount: {
        amount: 999.02,
        currencyCode: 'USD',
      },
      transferType: InvestmentTransferType.WITHDRAWAL,
      transferStatus: InvestmentTransferStatus.FUNDED,
      counterparty: 'High Yield Checking',
      initiatedDate: new Date().toISOString(),
      completedDate: new Date().toISOString(), // nullable my be in flux
      trades: [
        {
          tradeId: 101,
          displayName: 'Apple',
          symbol: 'AAPL',
          amount: 0.1,
          amountType: InvestmentAmountType.NOMINAL,
          status: InvestmentTradeStatus.PENDING,
        },
      ],
    } as InvestmentTransferActivityDetailV2,
    {
      __typename: 'InvestmentFeeActivityDetail',
      initiatedDate: new Date().toISOString(),
      activityId: 13,
      displayName: 'Advisory Fee',
      date: new Date().toISOString(),
      amount: {
        amount: 123.15,
        currencyCode: 'USD',
      },
      trades: [
        {
          tradeId: 101,
          displayName: 'Apple',
          symbol: 'AAPL',
          amount: 0.00313438,
          amountType: InvestmentAmountType.NOMINAL,
          status: InvestmentTradeStatus.PENDING,
        },
      ],
    } as InvestmentFeeActivityDetail,
    {
      __typename: 'InvestmentDividendActivityDetailV2',
      activityId: 11,
      displayName: 'Dividend from Apple',
      date: new Date().toISOString(),
      amount: {
        amount: 100,
        currencyCode: 'USD',
      },
      amountPerShare: { amount: 240.91, currencyCode: 'USD' },
      symbol: 'AAPL',
      instrumentName: 'Apple',
      trades: [
        {
          tradeId: 101,
          displayName: 'Apple',
          symbol: 'AAPL',
          amount: 0.00313438,
          amountType: InvestmentAmountType.NOMINAL,
          status: InvestmentTradeStatus.PENDING,
        },
      ],
    } as InvestmentDividendActivityDetailV2,
    {
      __typename: 'InvestmentInterestActivityDetail',
      activityId: 14,
      displayName: 'Interest from Brokerage',
      date: new Date().toISOString(),
      amount: {
        amount: 305,
        currencyCode: 'USD',
      },
      trades: [
        {
          tradeId: 101,
          displayName: 'Apple',
          symbol: 'AAPL',
          amount: 0.00313438,
          amountType: InvestmentAmountType.NOMINAL,
          status: InvestmentTradeStatus.PENDING,
        },
      ],
    } as InvestmentInterestActivityDetail,
    {
      __typename: 'InvestmentAcatGroupActivityDetailV2',
      activityId: 15,
      displayName: 'Account Transfer from Fidelity',
      date: new Date().toISOString(),
      amount: {
        amount: 305000,
        currencyCode: 'USD',
      },
      sourceAccount: '0226', // Incoming account transfer would be hidden Optionally shown
      destinationAccount: 'Roth IRA Companion', // Outgoing account transfer would be hidden Optionally shown
      transfers: [
        {
          __typename: 'InvestmentActivityAcatStock',
          displayName: 'Apple',
          direction: AcatDirection.INCOMING,
          quantity: 2.837,
          symbol: 'AAPL',
          instrumentName: 'Apple Inc',
        } as InvestmentActivityAcatStock,
        {
          __typename: 'InvestmentActivityAcatCash',
          displayName: 'Cash',
          direction: AcatDirection.INCOMING,
          amount: {
            amount: 5000,
            currencyCode: 'USD',
          },
        } as InvestmentActivityAcatCash,
      ],
    } as InvestmentAcatGroupActivityDetailV2,
  ],
}

export const mockGetInvestmentAccountActivity = graphql.query('investmentAccountActivity', () => {
  return HttpResponse.json({ data: { investmentAccountActivity: investmentAccountActivityMock } })
})

export const mockInvestmentAccountActivity = [mockGetInvestmentAccountActivity]
